<template>
  <div class="card-make-content">
    <!-- <ckeditor
      :editor="editor"
      v-model="editorData"
      :config="editorConfigData.editorConfig"
      style="height:0;display:none;"
    ></ckeditor> -->

    <div class="editor-wrapper" v-if="!isPreview || isDownload">
      <div class="card-tool">
        <div class="custom-row">
          <div class="custom-col" style="margin-right: 8px; cursor: pointer" @click="backHome">
            <div class="el-icon-arrow-left" style="font-size: 20px"></div>
          </div>
          <div class="custom-col" style="margin-top: 0">
            <!-- <div class="custom-tge green" style="width: 68px">自制</div> -->
            <!-- <div style="padding-top: 5px">
              答题卡ID：{{ answerSheet.acCardCardID }}
            </div> -->
            <div style="cursor: pointer; font-size: 16px" @click="backHome">返回</div>
          </div>

          <!-- <div class="custom-col">
            <div class="submit-text" style="top: -8px" @click="openAcDialog">
              <p>
                <img src="@/assets/images/save.png" style="height: 16px" />
              </p>
              <p>{{ saveText }}</p>
            </div>
          </div> -->
          <div class="custom-col">
            <div class="submit-text" style="display: inline-block;margin-right: 20px;" @click="handlePreview">
              <p class="el-icon-view" style="font-size: 20px"></p>
              <p>保存/下载</p>
            </div>
          </div>
          <!-- <div class="custom-col">
            <div class="submit-text" style="display: inline-block" @click="downloadPdf">
              <p class="el-icon-download" style="font-size: 20px"></p>
              <p>下载</p>
            </div>
          </div> -->
        </div>
      </div>
      <div class="card-make-box" v-loading="false">
        <!--  -->
        <LeftMenu @click="handleMenuClick"></LeftMenu>
        <div class="bd-le">
          <!-- 答题卡制作区 -->
          <div v-show="isNormal" class="message-box">
            <div class="message-con">
              为保证最佳的编辑效果，请将浏览器缩放还原为100%!（快捷键Ctrl+0）
            </div>
          </div>
          <div v-show="isBrowser" class="message-box">
            <div class="message-con">
              为保证最佳的编辑效果，请不要使用 360浏览器 或 微信 内进行答题卡制作（会造成间距不一致）。
            </div>
          </div>
          
          <div class="card-content">
            <template v-if="pageCell.length > 0">
              <div v-for="(page, pageIndex) in pageCell" :key="'page' + pageIndex" class="page-cell red-card" :class="{'small-card' : acCardSpacing}" 
                @mousedown="handlePageCellClick(pageIndex)" :style="{
                  width: `${page.layout.width}px`,
                  height: `${page.layout.height}px`,
                  position: page.layout.position,
                  left: page.layout.left,
                  top: `${page.layout.top}px`,
                  'margin-left': `${page.layout.marginLeft}px`,
                  padding: page.layout.padding,
                  //padding: `42px 34px`
                }">
                <div class="basics-card">
                  <div v-if="pageIndex == 0" class="ab-box" :class="{
                      'fz-model': answerSheet.acCardStudentCodeType == '6',
                    }">
                    <div v-if="answerSheet.acCardABSet" class="a-b basics-card-tips">
                      <div class="AB_wrapper">
                        <p class="mt">
                          <span class="c-t c-b c-b0"></span>
                          <span class="c-t no-margin">A卷</span>
                        </p>
                        <p class="mt">
                          <span class="c-t c-b c-b1"></span>
                          <span class="c-t no-margin">B卷</span>
                        </p>
                        <!-- <br /> -->
                        <!-- <br /> -->
                      </div>
                    </div>
                    <div class="card-name" :style="{
                        width: answerSheet.acCardABSet ? '86%' : '100%',
                      }">

                      <div v-show="!acCardHideOrcode && !qrCodeDataUrl" ref="qrcodeContainer" id="qrcode"
                        class="qrcodeBox"></div>

                      <!-- <textarea
                      class="titleArea"
                      placeholder="请输入答题卡标题"
                      v-model="answerSheet.acCardName"
                      style="
                        text-align: center;
                        resize: none;
                        top: 0px;
                        height: 44px;
                        font-size: 23px;
                        border-style: dashed;
                        line-height: 1.5;
                        word-break: break-all;
                        z-index: 1;
                      "
                    ></textarea> -->

                      <vue-ueditor-wrap ref="cardName" class="vue-ueditor-wrap" :destroy="true" id="myeditor"
                        mode="listener" @ready="ready" v-model="answerSheet.acCardNameHtml"
                        :config="UEDITOR_CONFIG_TITLE"></vue-ueditor-wrap>
                    </div>
                  </div>
                  <Basics v-if="showBasics(pageIndex)" :msg="{ pageIndex: pageIndex }" />
                  <!-- 封装线   v-if="answerSheet.acCardPanes == 6"-->
                  <PageLine v-if="
                      answerSheet.acCardStudentCodeType == 6 && pageIndex == 0
                    "></PageLine>
                </div>
                <div class="wrapper-content" :style="{ height: page.contentHeight + 'px' }">
                  <!-- <div id="div1" @click="xx">adfadsf</div> -->
                  <template v-for="(obj, index) in page.fillTopiclist">
                    <div class="topic-wrapper" :key="index" @click="handleTopicWrapperClick(index)">
                      <fill-topic v-if="obj.type === 1" :msg="{
                          ...obj,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }" :key="'cont' + index" ref="fillTopics" />
                      <objective-topic v-if="obj.type === 2" :msg="{
                          ...obj,
                          types: 1,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }" :key="'obj' + index" />
                      <answer-topic v-if="obj.type === 3" :msg="{
                          ...obj,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }" :key="'obj' + index" />
                      <writing-en-topic v-if="obj.type === 4" :msg="{
                          ...obj,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }" :key="'obj' + index" />
                      <writing-topic v-if="obj.type === 5" :msg="{
                          ...obj,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }" :key="'obj' + index" />
                      <choose-topic v-if="obj.type == 6" :msg="{
                          ...obj,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }" :key="'obj' + index" />
                      <non-answer-topic v-if="obj.type == 7" :msg="{
                          ...obj,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }" :key="'obj' + index" />  
                    </div>
                  </template>
                  <div id="test-obj-group" class="obj-group"></div>
                </div>
                <div class="page-num" style="
                    width: 100%;
                    text-align: center;
                    position: absolute;
                    left: 0;
                    bottom: 36px;
                  ">
                  -{{ pageIndex + 1 }}-
                </div>
              </div>
            </template>
          </div>

          <!-- 答题卡制作区end -->
        </div>
        <RightMenu @basicChange="handleBasicChange" @hand-data="handData" @hand-data-spacing="handDataSpacing"></RightMenu>
      </div>
    </div>
    <div class="preview-wrapper" :class="{ 'hide-score': !!answerSheet.acCardHideScore }">
      <div v-if="isPreview || isDownload">
        <!-- <div
          class="close el-icon-error"
          @click="handlePreviewClose(true)"
        ></div> -->
        <div class="close-down">
          <el-button type="success" size="small" @click="openAcDialog">
            保存
          </el-button>
          <el-button type="primary" size="small" @click="downloadPdf">下载</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button type="info" size="small" @click="handlePreviewClose(true)">关闭</el-button>
        </div>
        <!-- 答题卡预览区 -->
        <div id="preview-page-wrap">
          <preview-wrapper :is-preview="isPreview" :acCardHideOrcode="acCardHideOrcode"></preview-wrapper>
        </div>
      </div>
    </div>
    <span class="text-size-dom" style="
        font-family: '宋体' !important;
        background: red;
        position: absolute;
        left: -10000px;
      ">&nbsp;</span>

    <AcDialog ref="ac_dialog" @saveCard="handleSaveCard"></AcDialog>
    <!-- 弹窗 -->
    <FuctionalDlg ref="fuctionalDlg"></FuctionalDlg>
  </div>
</template>

<script>
  import JQ from "jquery";
  import * as QRCode from 'qrcodejs2';
  import VueUeditorWrap from "vue-ueditor-wrap";
  import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
  import Functional from "@/components/Functional";
  import { UEDITOR_CONFIG_TITLE } from "@/subjects/constant";
  import Basics from "@/components/TopicMakeBox/BasicsCardBox";
  import FillTopic from "@/components/TopicShow/FillTopic";
  import ObjectiveTopic from "@/components/TopicShow/ObjectiveTopic";

  // import AnswerTopic from "@/components/TopicShow/AnswerTopic";
  import ChooseTopic from "@/components/TopicShow/ChooseTopic";
  import AnswerTopic from "@/components/TopicShow/AnswerTopic";
  import WritingEnTopic from "@/components/TopicShow/WritingEnTopic";
  import WritingTopic from "@/components/TopicShow/WritingTopic";
  import NonAnswerTopic from "@/components/TopicShow/NonAnswerTopic";

  // import "@ckeditor/ckeditor5-build-inline/build/translations/zh-cn";

  import cardOperate from "@/assets/js/utils/cardOperate";
  import html2canvas from 'html2canvas';

  import makeCard from "../services/makeCard";
  import JsPDF from "jspdf";
  import { BlankModel } from "../subjects/blank/Blank.model";
  import { ObjectiveModel } from "../subjects/objective/Objective.model";
  import { AnswerModel } from "../subjects/answer/Answer.model";
  import { WriteEnModel } from "../subjects/writeEn/WriteEn.model";
  import { WriteModel } from "../subjects/write/Write.model";
  import { ChooseModel } from "../subjects/choose/Choose.model";
  import { nonAnswerAreaModel } from "../subjects/nonAnswerArea/nonAnswerArea.model";
  import MyPage from "@/subjects/Page";
  import { DEFAULT_PAGECELL, THS, THSObj } from "@/subjects/constant";
  import PreviewWrapper from "@/views/PreviewWrapper";
  import { studentMsgEffect, winZoom } from "@/utils/common";
  import { transformSubjects } from "@/assets/js/utils/base/parseJson";
  import { stringifyJsonForSubjects } from "@/assets/js/utils/base/stringifyJson";
  import AcDialog from "./components/AcDialog";
  import LeftMenu from "./components/LeftMenu.vue";
  import RightMenu from "./components/RightMenu.vue";
  import PageLine from "@/components/TopicMakeBox/PageLine.vue";
  import FuctionalDlg from "./components/card/fuctional-dlg.vue";
  import { getAllPosition } from '@/utils/position.js'
  import { getKaohaoInfo, getObjectiveInfo, getLocalRegionInfo, getPositionPoints, getSubjectiveInfo, getScoreBoxPositions, getScoreDFPositions, getStuInfoReactions, getSize, getQuekao } from '@/utils/posFormatting.js'

  // 用来恢复json序列化的对象方法
  const SUBJECTS_TYPE_MAP = {
    1: BlankModel,
    2: ObjectiveModel,
    3: AnswerModel,
    4: WriteEnModel,
    5: WriteModel,
    6: ChooseModel,
    7: nonAnswerAreaModel,
  };

  export default {
    name: "CardMake",
    components: {
      Functional,
      Basics,
      ObjectiveTopic, // 客观题组件
      FillTopic, // 填空题组件
      AnswerTopic, // 解答题组件
      ChooseTopic,
      NonAnswerTopic,
      WritingEnTopic,
      WritingTopic,
      PreviewWrapper,
      VueUeditorWrap,
      AcDialog,
      LeftMenu,
      RightMenu,
      FuctionalDlg,
      PageLine,
    },
    computed: {

      UEDITOR_CONFIG_TITLE() {
        return UEDITOR_CONFIG_TITLE;
      },
      // ...mapState("cardMake", {
      //   answerSheet: (state) => state.answerSheet,
      // }),
      ...mapGetters({
        answerSheet: "answerPanel/answerSheet",
      }),
      ...mapState("card", {
        pageCell: (state) => state.pageCell, //纸张的数据
        subjects: (state) => state.subjects, //纸张的数据
        pageCellCopy: (state) => state.pageCellCopy, //纸张的数据
        THS: (state) => state.THS, //小题题号
        pageCellString: (state) => state.pageCellString,
        basicsCheckList: (state) => state.basicsCheckList,
      }),

    },
    data() {
      return {
        isDownload: false,
        isA: true,
        isB: false,
        localityPageCellData: [], //第一次加载的整栏所有数据
        isPreview: false,
        editor: null,
        editorData: "",
        cardName: "",
        isNormal: false,
        isBrowser: false,
        frequentSave: false,
        saveText: "保存",
        acCardQuestTh: [],
        acCardCardID: "",
        toolbarClicked: false,
        acCardName: "",
        editorInstance: undefined,
        acCardGuid: this.$route.query.guid,
        functionType: "",
        qrCodeDataUrl: '',
        acCardHideOrcode: true,
        acCardSpacing:false,
      };
    },
    created() {
      // this.editor = this.$ckEditor;
      // this.cardName = this.answerSheet.acCardName;

    },
    mounted() {
      this.showWindowZoomMessage();
      this.is360Browser();
      this.isWeChat();
      window.onresize = () => {
        this.showWindowZoomMessage();
        this.is360Browser();
        this.isWeChat();
      };
      const { guid } = this.$route.query;
      this.setPageCell(DEFAULT_PAGECELL);
      this.setSubjects([]);
      this.setTHS(THS);
      guid && this.fetchCardDetail(guid);
      this.addListenerBackAction();

      if (this.acCardGuid && !this.acCardHideOrcode) {
        this.$nextTick(() => {
          this.initQRCode()
        });
      }
    },
    beforeDestroy() {
      sessionStorage.setItem("pageCell", null);
      sessionStorage.setItem("subjects", null);
      // 监听浏览器按键销毁
      document.onkeydown = null;
    },
    methods: {
      handData(data) {
        console.log('handData::::::', data);
        this.acCardHideOrcode = data;
      },
      handDataSpacing(data){
        this.acCardSpacing = data;
      },
      initQRCode() {
        try {
          const containerEl = this.$refs.qrcodeContainer?.$el ||
            document.getElementById('qrcode');

          if (containerEl) {
            const codes = new QRCode(containerEl, {
              text: this.acCardGuid.toString(),
              width: 68,
              height: 68,
              colorDark: '#000000',
              colorLight: '#ffffff',
            });
          }
        } catch (error) {

        }

      },
      ready(editorInstance) {
        this.editorInstance = editorInstance;
        const myeditor = document.getElementById(editorInstance.key);
        const toolbar = myeditor.querySelector(".edui-editor-toolbarbox");
        toolbar.onclick = () => {
          this.toolbarClicked = true;
        };
        this.showToolbarWhenFocus(editorInstance, toolbar);
        this.hideToolbarWhenFocus(editorInstance, toolbar);
        this.limitEditorEnter(editorInstance);
        const timer = setTimeout(() => {
          let myeditorNew = document.getElementById(editorInstance.key);
          this.showWheel(myeditorNew);
          clearTimeout(timer);
        }, 1000);
        //
        //this.setPlaceHolder();
      },
      /** 设置答题卡 */
      setPlaceHolder() {
        var source = UE.getEditor(this.editorInstance.key);

        window.UE.Editor.prototype.placeholder = function (justPlainText) {
          var _editor = this;
          _editor.addListener("focus", function () {
            var localHtml = _editor.getPlainTxt();
            if (localHtml.trim() === justPlainText.trim()) {
              _editor.setContent("");
            }
          });
          _editor.addListener("blur", function () {
            var localHtml = _editor.getContent();
            if (!localHtml) {
              _editor.setContent(
                '<p style="color: #CDCDCD">' + justPlainText + "</p>"
              );
            }
          });
          _editor.ready(function () {
            _editor.fireEvent("blur");
          });
        };
        source.placeholder("请输入答题卡名称");
      },
      setPlaceHolderData() {
        const myeditor = document.getElementById(this.editorInstance.key);
        const editor = this.$refs.cardName[0].editor;
        // 使用 UEditor API 添加 placeholder 样式
        editor.addListener("ready", () => {
          if (!this.answerSheet.acCardName) {
            const body = editor.body;
            body.innerHTML = '<p class="placeholder">请输入答题卡名称</p>';
            body.style.color = "#cdcdcd";
            // body.style.fontStyle = "italic";
          }
        });
        // 添加事件监听，处理 focus 和 blur
        editor.addListener("focus", () => {
          const body = editor.body;
          const placeholder = body.querySelector(".placeholder");
          if (placeholder) {
            placeholder.remove();
          } else {
            body.innerHTML = this.answerSheet.acCardName || "<p></p>";
          }
        });

        editor.addListener("blur", () => {
          const body = editor.body;
          if (!this.answerSheet.acCardName) {
            body.innerHTML = '<p class="placeholder">请输入答题卡名称</p>';
            body.style.color = "#aaa";
            body.style.fontStyle = "italic";
          }
        });
      },
      /**
       * 监听浏览器按键
       */
      addListenerBackAction() {
        document.onkeydown = (e) => {
          e = e ? e : window.event;
          const tagName = e.srcElement && e.srcElement.nodeName;
          if (tagName != "INPUT" && tagName != "TEXTAREA") {
            const keyCode = e.switch ? e.which : e.keyCode; // e.switch兼容火狐浏览器的键盘
            if (keyCode == 8) {
              return false;
            }
          }
        };
      },
      handleMenuClick(type) {
        this.functionType = type;
        // if (type == 1) {
        //   this.$refs.fuctionalDlg && this.$refs.fuctionalDlg.submitBlank2();
        // } else {
        this.$refs.fuctionalDlg &&
          this.$refs.fuctionalDlg.open({
            functionType: type,
          });
        // }
      },
      // 设置考生信息
      handleBasicChange(modelType) { },
      //
      showToolbarWhenFocus(editorInstance, toolbar) {
        editorInstance.addListener("focus", (editor) => {
          toolbar && (toolbar.style.display = "block");
          this.toolbarClicked = false;
        });
      },
      hideToolbarWhenFocus(editorInstance, toolbar) {
        editorInstance.addListener("blur", (editor) => {
          setTimeout(() => {
            !this.toolbarClicked && toolbar && (toolbar.style.display = "none");
          }, 200);
        });
      },
      /**
       * 当标题的内容大于等于2行的时候 限制回车
       */
      limitEditorEnter(editorInstance) {
        editorInstance.addListener("keydown", (type, event) => {
          // console.log(" => ", event.target, 2, event.target.childNodes);
          const nodes = event.target.childNodes;
          if (event.which == 13 && nodes.length >= 2) {
            event.cancelBubble = true;
            event.preventDefault();
            event.stopPropagation();
          }
        });
      },

      showWheel(myeditor) {
        // 显示滚动条
        try {
          const iframe =
            myeditor.querySelector(".edui-editor-iframeholder") &&
            myeditor
              .querySelector(".edui-editor-iframeholder")
              .querySelector("iframe");
          iframe.contentWindow.document.body &&
            iframe.contentWindow.document.body.style &&
            (iframe.contentWindow.document.body.style.overflow = "auto");
        } catch (e) {
          console.error("showWheel方法报错", e.message);
        }
      },

      //显示考生信息
      showBasics(pageIndex) {
        let showBasics = false;
        const { acCardPanes, acCardPint } = this.answerSheet;
        if (pageIndex === 0) {
          return true;
        }
        if (acCardPanes === 1) {
          // 一栏
          if (acCardPint == 1) {
            // 单面打印
            return true;
          } else if (acCardPint == 2) {
            // 双面打印
            return (pageIndex + 1) % 2 == 1 ? true : false;
          }
        } else if (acCardPanes === 2) {
          // 二栏
          if (acCardPint == 1) {
            // 单面打印
            return (pageIndex + 1) % 2 == 1 ? true : false;
          } else if (acCardPint == 2) {
            // 双面打印
            return (pageIndex + 1) % 4 == 1 ? true : false;
          }
        } else {
          // 三栏
          if (acCardPint == 1) {
            // 单面打印
            return (pageIndex + 1) % 3 == 1 ? true : false;
          } else if (acCardPint == 2) {
            // 双面打印
            return (pageIndex + 1) % 6 == 1 ? true : false;
          }
        }
      },
      /**
       * 单双面打印重新整理布局
       */
      resetLayoutByAcCardPint() { },
      ...mapActions({
        answerSheetAction: "answerPanel/answerSheetAction",
      }),
      getPageElements() {
        const pageWraps = document.querySelectorAll('.page-wrap');
        return pageWraps.length > 0 ?
          Array.from(pageWraps) :
          Array.from(document.querySelectorAll('.page-cell'));
      },
      uploadBase64(data) {
        return new Promise((resolve, reject) => {
          makeCard.uploadImage(data)
            .then((res) => {
              if (res.errno == 0) {
                resolve(res);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      },
      fetchAddCard(guid, from, data = null) {

        document.querySelector(".preview-wrapper").style.opacity = 0;
        document.querySelector(".preview-wrapper").style.zIndex = -1;
        let answerSheet = data || this.answerSheet;
        this.isPreview = true;
        this.resetPosition(this.answerSheet);
        this.isDownload = true;
        const acCardQuestTh =
          stringifyJsonForSubjects(this.acCardQuestTh, { guid: guid }) || [];
        let timer1 = setTimeout(() => {
          if (this.saveText != "保存") {
            this.$message({
              message: "未响应,请重试!",
              type: "warning",
            });
            this.saveText = "保存";
          }
          clearTimeout(timer1);
        }, 8000);

        // 获取页面坐标
        let position = getAllPosition(this.answerSheet);
        // 考号信息
        let kaohaoInfo = getKaohaoInfo(this.answerSheet, position);
        //主观题
        let objectiveInfo = getObjectiveInfo(acCardQuestTh, position);

        //特征区域
        let localRegionInfo = getLocalRegionInfo(this.answerSheet);

        let squaresInfo = getPositionPoints(this.answerSheet);

        let subjectiveInfo = getSubjectiveInfo(acCardQuestTh, this.answerSheet);

        let score = getScoreBoxPositions();

        let scoreDF = getScoreDFPositions();

        let stu_info = getStuInfoReactions();

        let size = getSize();

        let quekao = getQuekao();

        let cardNameHtml = this.answerSheet.acCardNameHtml;
        //console.log("cardNameHtml===log", cardNameHtml);
        //
        let cardName = this.extractTextFromHtml(cardNameHtml);
        //
        let timer = setTimeout(async () => {
          const pdfDom = document.querySelector("#preview-page-wrap");
          let images = []
          //保存为图片  
          try {
            await this.$nextTick();

            const hasPageWrap = document.querySelectorAll('.page-wrap').length > 0;

            const pageContainers = Array.from(
              hasPageWrap
                ? document.querySelectorAll('.page-wrap')
                : document.querySelectorAll('.page-cell:not(.red-card)') // 排除带有.red-card的元素
            );

            for (const [index, page] of pageContainers.entries()) {
              const canvas = await html2canvas(page, {
                scale: 1,
                useCORS: true,
              });

              const imageData = canvas.toDataURL('image/png', 1.0);
              let res = await this.uploadBase64({
                base64Data: imageData,
                index: index
              });
              const { errno, data } = res;
              if (errno == 0) {
                images.push({ url: data.url, index: index });
              } else {
                this.$message.error('图片上传失败，请重试');
                return
              }
            }
          } catch (error) {
            console.error('截图或上传失败:', error);
            this.$message.error('操作失败，请重试');
            return
          }


          const delGuid = this.getDelGuid(this.acCardQuestTh);
          const addCardParam = {
            delGuid: delGuid.join(","),
            acCard: {
              acCardGuid: guid,
              acCardCardID: this.acCardCardID,
              ...this.answerSheet,
              acCardName: answerSheet.acCardName || cardName,
              // acCardName:
              //   answerSheet.acCardName &&
              //   answerSheet.acCardName
              //     .replace(/<p>/g, function (match) {
              //       return (match = "");
              //     })
              //     .replace(/<\/p>/g, function (match) {
              //       return (match = "");
              //     })
              //     .replace(/ /g, function (match) {
              //       return (match = "");
              //     }),
              acPeriod: answerSheet.acPeriod,
              acKmCode: answerSheet.acKmCode,
              acksType: answerSheet.acksType,
            },
            acCardCoordinate: [],
            acCardQuestTh: acCardQuestTh,
            acQuestType: [],
            acCardHtml: {
              // CardHtmlGuid: "",
              all: pdfDom.innerHTML,
              abType: 0,
              acCardName: cardNameHtml,
              designText: JSON.stringify({
                pageCell: this.pageCell,
                subjects: this.subjects,
                // 已经添加的题号列表
                THList: this.THS,
                acCardName: answerSheet.acCardName,
                basicsCheckList: this.basicsCheckList,
              }),
            },
            //position,
            kaohaoInfo,
            objectiveInfo,
            localRegionInfo,
            squaresInfo,
            subjectiveInfo,
            score,
            scoreDF,
            stu_info,
            images,
            quekao,
            size,
          };
          try {
            let result = await makeCard.addCard(addCardParam);
            let { errno, data } = result;
            console.log('fetchAddCard result::::::::::::', result)
            // this.acDialogV = false;
            this.$refs.ac_dialog.handlerClose();
            //
            if (errno != 0) {
              this.saveText = "保存";
            } else {
              // this.$message({
              //   message: "操作成功~",
              //   type: "success",
              // });
              if (from == "download") {
                this.downloadPdfAction();
              } else {
                this.acCardGuid = data?.acCardId;
                // 保存成功需要重新刷新下fetchCardDetail接口 为了获取acCardQuestTh 更新acCardQuestTh以便删除大提操作及时比对更新
                // this.$router.query.guid=data?.acCardId
                this.$router.replace({
                  path: "/cardNew",    // 保持当前的路由路径
                  query: { guid: this.acCardGuid }  // 你想要更新的 query 参数
                },
                  () => { },
                  (err) => {
                    // 可在此处打印错误日志
                    console.debug('路由跳转被阻止:', err.message)
                  });
                this.fetchCardDetail(data?.acCardId);
                this.initQRCode();

                // this.$alert("保存答题卡成功", "提示", {
                //   confirmButtonText: "确定",
                // });
                this.$message({
                  message: "保存答题卡成功",
                  type: "suscess"
                });
              }
              this.saveText = "保存";
              this.isPreview = false;
            }
            clearTimeout(timer);
            clearTimeout(timer1);
          } catch (e) {
            console.log('fetchAddCard::::::::::::', e)
            this.saveText = "保存";
            // this.acDialogV = false;
            this.$refs.ac_dialog.handlerClose();
            clearTimeout(timer1);
          }
        }, 800);
      },
      extractTextFromHtml(htmlString) {
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlString;
        return tempDiv.textContent || tempDiv.innerText || "";
      },
      // 获取删除的大题型guid
      getDelGuid(roughcastSubjects) {
        const delThs = roughcastSubjects
          .filter((item, index) => {
            return (
              item.questTh != (this.subjects[index] && this.subjects[index].th)
            );
          })
          .map((item) => {
            return item.questTh_Guid;
          });
        return delThs;
      },
      // 获取答题卡详情
      async getDetailAcCard(acCardId) {
        let { data } = await makeCard.getDetailAcCard({
          acCardId: acCardId,
          abType: 0,
        });
        if (data) {
          let { acCard, acCardHtml, acCardQuestTh, acQuestType } = data;
          this.acCardQuestTh = acCardQuestTh || []; //自制答题卡 除了第一次新增之后 每次修改大题题型都需要acCardQuestTh中的questTh_Guid
          this.acCardCardID = acCard.acCardCardID || "";
          this.answerSheetAction({
            ...acCard,
            acCardName: acCard.acCardName,
            acCardNameHtml: acCardHtml.acCardNameHtml,
          });
        }

        return data || {};
      },
      //
      async fetchCardDetail(acCardGuid) {
        const data = await this.getDetailAcCard(acCardGuid);
        let { acCard, acCardHtml, acCardQuestTh, acQuestType } = data;
        //this.$set(acCard, 'acCardColor', '#ff2020');
        const root = document.documentElement;
        if (acCard?.acCardColor) {
          root.style.setProperty("--card-color", acCard.acCardColor);
        }
        if (acCard && (acCard.acCardDJType == 0 || acCard.acCardDJType == 2)) {
          // 自制
          this.answerSheetAction({
            ...acCard,
            acCardName: acCard.acCardName,
            acCardNameHtml: acCardHtml.acCardName,
          });
          if (!acCardHtml.designText) {
            // 这里存在扫描题卷情况 先判断有没有designtext字段 没有再判断acCardQuestTh 都没有才能生成空的答题卷
            if (Array.isArray(acCardQuestTh) && acCardQuestTh.length) {
              this.createPageCellByZj(acCard, acCardQuestTh, acQuestType);
            } else {
              this.setPageCell(DEFAULT_PAGECELL);
              this.setSubjects([]);
              this.setTHS(THS);
              this.resetPageCell({
                acCardPanes: acCard.acCardPanes,
              });
            }
            return;
          }
          studentMsgEffect();
          const designText = JSON.parse(acCardHtml.designText);
          if (Array.isArray(designText)) {
            this.setPageCell(designText);
            this.setTHS(THS);
          } else {
            const { pageCell, subjects, THList, acCardName, basicsCheckList } =
              designText;
            this.renderPageByDesignTxt(designText);
          }
        } else {
          // 如果是组卷第一次直接读组卷 第二次读保存的html
          if (acCardHtml && acCardHtml.designText) {
            const designText = JSON.parse(acCardHtml.designText);
            this.renderPageByDesignTxt(designText);
            this.answerSheetAction({
              ...acCard,
            });
          } else {
            this.createPageCellByZj(acCard, acCardQuestTh, acQuestType);
            this.answerSheetAction({
              ...acCard,
              acCardName: acCard && acCard.acCardName,
            });
          }
        }
      },
      renderPageByDesignTxt(designText) {
        const { pageCell, subjects, THList, acCardName, basicsCheckList } =
          designText;
        acCardName &&
          this.answerSheetAction({
            acCardName: acCardName,
          });
        basicsCheckList && this.setBasicsCheckList(basicsCheckList);
        subjects &&
          subjects.forEach((subject) => {
            Object.setPrototypeOf(
              subject,
              SUBJECTS_TYPE_MAP[subject.type].prototype
            );
            Object.setPrototypeOf(subject.page, MyPage.prototype);
          });
        this.setPageCell(pageCell || "");
        this.setSubjects(subjects || []);
        const sortTHS = [...new Set(THList)].sort((a, b) => {
          return THSObj[a] - THSObj[b];
        });
        this.setTHS(sortTHS);
      },
      createPageCellByZj(acCard, acCardQuestTh, acQuestType) {
        // 组卷
        this.answerSheetAction(acCard);
        const resultSubjects = transformSubjects(acCardQuestTh, acQuestType, {
          BlankModel,
          AnswerModel,
          WriteEnModel,
          WriteModel,
          ChooseModel,
          ObjectiveModel,
        });
        this.setSubjects(resultSubjects);
        this.resetPageCell({
          acCardPanes: this.answerSheet.acCardPanes,
          index: 0,
        });
      },
      ...mapMutations({
        setCurrentPageNum: "card/setCurrentPageNum",
        resetPosition: "card/resetPosition",
        returnPosition: "card/returnPosition",
        restorePageCell: "card/restorePageCell",
        setPageCell: "card/setPageCell",
        setSubjects: "card/setSubjects",
        resetPageCell: "card/resetPageCell",
        setTHS: "card/setTHS",
        setPageCellString: "card/setPageCellString",
        setBasicsCheckList: "card/setBasicsCheckList",
      }),
      reloadPageCell() {
        const restorePageCell = JSON.parse(sessionStorage.getItem("pageCell"));
        const subjects = JSON.parse(sessionStorage.getItem("subjects"));
        this.restorePageCell({
          pageCell: restorePageCell,
          subjects: subjects,
        });
      },
      showWindowZoomMessage() {
        const per = winZoom();
        this.isNormal = per !== 100;
      },
      // 判断是否为360浏览器或者微信浏览器
      is360Browser() {
        const userAgent = navigator.userAgent.toLowerCase();
        this.isBrowser = userAgent.indexOf('360se') > -1 || userAgent.indexOf('360ee') > -1;
      },
      isWeChat() {
        const userAgent = navigator.userAgent.toLowerCase();
        this.isBrowser = userAgent.indexOf('micromessenger') > -1;
      },
      previewPage() {
        this.isPreview = true;
      },
      backHome() {
        this.$confirm(
          "此操作将返回到列表页，编辑的答题卡如果未保存将会丢失, 是否继续?！",
          "提示",
          {
            cancelButtonText: "取消",
            confirmButtonText: "确定",
          }
        ).then(() => {
          this.$router.push({ path: "/" });
          this.answerSheetAction({
            acCardName: "",
            acCardPanes: 1, //布局：1、一栏，2、二栏，3三栏
            acCardYJType: 1, //评阅方式： 0、手批，1、网阅 2 打分
            acCardDJType: 0, // 答卷类型: 0-自制, 1-组卷
            acCardStudentCodeType: 0, //考号填写模式：0-填涂考号， 1-条码 ，2-手写考号
            acCardExamNumber: 8, //考号位数
            acCardMissSign: false, //缺考标记：显示-true，隐藏-false
            acCardHideScore: false, //隐藏分值：显示-true，隐藏-false
            acCardHideOrCode: true, //隐藏二维码：显示-false，隐藏-true
            acCardPint: 2, //单面打印：1-单面  2-双面
            acCardABSet: false, //AB卷：开启-true，关闭-false
            // abPaperModel: ['1'], //答案内AB卷设置
            acKmCode: "", //科目
            acPeriod: "", //年级
            acksType: "", //类型
            acRedCard: false, // 是否红色答题卡
            acCardColor: "#333333",
            acCardNameHtml: "", //答题卡名称html
            acCardSpacing: false,
          });
        });
      },
      handleTopicWrapperClick(index) { },
      // 保存
      handleSave(from, data = null) {
        if (this.frequentSave) {
          return;
        }
        // if (!this.acCardGuid) {
        //   this.acDialogV = true;
        //   return;
        // }
        this.saveText = "正在保存..";
        this.frequentSave = true;

        let saveTimer = setTimeout(() => {
          // sessionStorage.setItem("pageCell", JSON.stringify(this.pageCell));
          // sessionStorage.setItem("subjects", JSON.stringify(this.subjects));
          this.frequentSave = false;
          const { guid } = this.$route.query;
          // 这里用定时器的原因是，富文本编辑器失焦才会保存数据，用户如果编辑完直接点击预览，数据不能及时保存
          const timer = setTimeout(() => {
            this.answerSheet.acCardNameHtml || this.answerSheet.acCardName
              ? this.fetchAddCard(guid, from, data)
              : this.warningAlert();
            clearTimeout(timer);
          }, 200);
          clearTimeout(saveTimer);
        }, 1000);
      },
      //
      openAcDialog() {
        this.$refs.ac_dialog.handlerOpen(this.acCardGuid);
      },

      handleSaveCard(data) {
        // this.acDialogV = true;

        this.handleSave("save", data);
        // this.fetchAddCard(this.$route.query.guid, "save");
      },
      //
      warningAlert() {
        this.saveText = "保存";
        this.$message({
          message: "请输入答题卡名称",
          type: "warning",
        });
        // this.acDialogV=false
        this.$refs.ac_dialog.handlerClose();
      },
      //预览
      handlePreview() {
        // 这里用定时器的原因是，富文本编辑器失焦才会保存数据，用户如果编辑完直接点击预览，数据不能及时保存
        if (!this.answerSheet.acCardNameHtml && !this.answerSheet.acCardName) {
          this.warningAlert();
          return;
        }
        let timer = setTimeout(() => {

          document.querySelector(".preview-wrapper").style.opacity = 1;
          document.querySelector(".preview-wrapper").style.zIndex = 2000;
          // document.querySelector(".preview-wrapper").style.fontFamily = '"Helvetica Neue",Helvetica,Arial,sans-serif'
          this.isPreview = true;
          studentMsgEffect();
          this.resetPosition(this.answerSheet);
          this.setPageCellString(JSON.stringify(this.pageCell));
          clearTimeout(timer);
        }, 1000);
      },
      downloadPdf() {
        this.$confirm("是否保存当前答题卡并下载?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const timer = setTimeout(() => {
              this.handleSave("download");
              clearTimeout(timer);
            }, 1500);
          })
          .catch(() => { });
      },
      downloadPdfAction() {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: "<strong>生成答题卡PDF中,请稍后......</strong>",
          duration: 0,
        });
        // 因为html2Canvas不能将隐藏的元素保存下来 所以要先显示然后将元素opacity置为0
        this.isDownload = true;
        studentMsgEffect();
        const timer = setTimeout(() => {
          // this.handlePreview();
          document.querySelector(".preview-wrapper").style.opacity = 1;
          document.querySelector(".preview-wrapper").style.zIndex = 200000;
          this.isPreview = true;
          this.resetPosition(this.answerSheet);
          document.querySelector(".preview-wrapper").style.zIndex = -1;
          let myPdfDom = document.querySelector("#preview-page");
          this.getPdf(myPdfDom)
            .then((canvas) => {
              let contentWidth = canvas.width;
              let contentHeight = canvas.height;
              if (this.answerSheet.acCardPanes === 1) {
                this.savePdfA4(canvas, contentWidth, contentHeight);
              } else {
                this.savePdfA3(canvas, contentWidth, contentHeight);
              }
              this.$message.closeAll();
              this.handlePreviewClose();
              this.$message({
                message: "操作成功~",
                type: "success",
              });
            })
            .catch((e) => { })
            .then(() => {
              this.isDownload = true;
              this.$message.closeAll();
            });
          clearTimeout(timer);
        }, 100);
      },
      savePdfA4(canvas, contentWidth, contentHeight) {
        let pageHeight = (contentWidth / 595.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 595.28;
        let imgHeight = (602 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);
        let PDF = new JsPDF("", "pt", "a4");
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            // 每页会多出17点多的长度 所以拿18乘以页数
            if (leftHeight > parseInt(contentHeight / pageHeight) * 18) {
              PDF.addPage();
            }
          }
        }
        var title = this.answerSheet.acCardName;
        PDF.save(title + ".pdf");
      },
      savePdfA3(canvas, contentWidth, contentHeight) {
        let pageHeight = (contentWidth / 1191) * 842;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 1191;
        let imgHeight =
          ((this.answerSheet.acCardPanes === 2 ? 1200 : 1355) / contentWidth) *
          contentHeight;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);
        let PDF = new JsPDF("l", "pt", "a3");
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          const pageLen =
            parseInt(contentHeight / pageHeight) *
            (this.answerSheet.acCardPanes === 2 ? 21 : 0);
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 842;
            if (leftHeight > pageLen) {
              PDF.addPage();
            }
          }
        }
        var title = this.answerSheet.acCardName;
        PDF.save(title + ".pdf");
      },
      handlePreviewClose(fromCloseBtn) {
        this.isPreview = false;
        document.querySelector(".preview-wrapper").style.zIndex = -1;
        fromCloseBtn && this.setPageCell(this.pageCellString);
        console.log("handlePreviewClose====log", JSON.parse(this.pageCellString));
        // this.returnPosition();
      },
      // previewClose() {
      //   this.isPreview = false;
      // },
      pxDpi() {
        //1栏2栏210*297（180*257）left:15mm,3栏146*297（124*257）left:20mm
        //mm转PX公式px=(mm/25.4)*dip(96)
        //px/dip=英寸，英寸*25.4=mm
        let arrDPI = new Array();
        if (window.screen.deviceXDPI != undefined) {
          arrDPI[0] = window.screen.deviceXDPI;
          arrDPI[1] = window.screen.deviceYDPI;
        } else {
          let tmpNode = document.createElement("DIV");
          tmpNode.style.cssText =
            "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
          document.body.appendChild(tmpNode);
          arrDPI[0] = parseInt(tmpNode.offsetWidth);
          arrDPI[1] = parseInt(tmpNode.offsetHeight);
          tmpNode.parentNode.removeChild(tmpNode);
        }
        return arrDPI;
      }, //待用

      // 设置当前鼠标所在page下标到全局
      handlePageCellClick(index) {
        this.setCurrentPageNum(index);
      },
      //添加修添加题型
      async updateSubjectsByindex(updateSubject) {
        const index = this.updateSubjectIdx;
        // 这里的编辑更新肯定需要更改题型的html和高度 不可能保存之前的数据
        updateSubject.setFromEdit(true);
        await this.updateSubjects({
          index: index,
          data: updateSubject,
        });
        await this.resetPageCell({
          acCardPanes: this.answerSheet.acCardPanes,
          index: index,
        });
        if (updateSubject.type != 2) {
          return;
        }
        // 这样写是为了 dom更新之后 处理选择题 精确计算选择题的高度
        updateSubject = await setObjectiveHeight(updateSubject);
        await this.updateSubjects({
          index: index,
          data: new ObjectiveModel(updateSubject),
        });
        await this.resetPageCell({
          acCardPanes: this.answerSheet.acCardPanes,
          index: index,
        });
      },
      examNumInfo(v) {
        this.answerSheetAction({ acCardStudentCodeType: v });
        let pageData = {
          isDefault: false, //是否切换栏数了
        };
        this.changeCardStudentCode();
        this.resetPageCell({
          acCardPanes: this.answerSheet.acCardPanes,
          acCardStudentCodeType: v,
        });
      }, //改变考号信息方式
      changeCardStudentCode(acCardPanes) {
        if (
          acCardPanes == 3 &&
          this.answerSheet.acCardStudentCodeType === 0 &&
          this.answerSheet.acCardExamNumber >= 9
        ) {
          // 三栏
          this.answerSheetAction({ acCardExamNumber: 9 });
        }
        if (
          acCardPanes != 3 &&
          this.answerSheet.acCardStudentCodeType === 0 &&
          this.answerSheet.acCardExamNumber >= 14
        ) {
          // 三栏
          this.answerSheetAction({ acCardExamNumber: 14 });
        }
      },

    },
    watch: {
      "answerSheet.acCardName"(newVal) { },
      "answerSheet.acCardStudentCodeType"(newVal) {
        this.examNumInfo(newVal);
      },
      "acCardHideOrcode"(newVal) {
        this.acCardHideOrcode = newVal;
        if (!this.acCardHideOrcode) {
          this.initQRCode()
        }
      },
      "acCardSpacing"(newVal){
        this.acCardSpacing = newVal;
        console.log("acCardSpacing:::", newVal)
      }
    },
  };
</script>

<style lang="scss">
  @import url("../assets/css/card.scss");

  .card-make-content {
    textarea {
      resize: none !important;
    }

    .ab-box {
      //overflow: hidden;

      // border: 1px solid #dcdfe6;
      // border-radius: 4px;
      .a-b {
        border: none;
        /*border: 1px solid #000;*/
        float: left;
        /*height: 66px;*/
        width: 10%;
        margin-right: 8px;

        /*.c-b0 {*/
        /*  background: #000;*/
        /*}*/
        .no-margin {
          margin-right: 0;
          margin-left: 0;
        }

        .mt {
          margin-bottom: 5px;
        }
      }

      .AB_wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .input-name {
      width: 70%;
    }

    .ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label {
      width: 3em;
    }

    .topic-bd {
      padding: 0 15px !important;

      .fill-cont {
        overflow: visible;
      }
    }

    .message-box {
      width: 100%;

      .message-con {
        position: fixed;
        top: 62px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        margin: 0 auto;
        font-size: 16px;
        width: 540px;
        color: #f00;
        border: 1px solid #f00;
        z-index: 9;
      }
    }

    .code-info {
      position: absolute;
      left: 44px;
      top: 4px;
      width: 300px;
      height: 47px;

      .appTitle {
        display: inline-block;
        font-size: 12px;
        vertical-align: middle;
        height: 57px;
        padding-left: 4px;
      }

      img {
        width: 60px;
        max-width: 100%;
        max-height: 60px;
      }
    }

    .card-name {
      // display: flex;
      // justify-content: center;
      // flex-direction: column;
      font-size: 16px;
      text-align: center;
      position: relative;

      .el-input__count {
        right: 20px;
      }
    }

    .wrapper-content {
      // border: 1px solid #409eff;
      border-radius: 10px;
      // padding: 0 10px;
      // padding: 0 10px 10px 10px;
    }

    .card-tool {
      height: 40px;
      padding-top: 20px;
      background: linear-gradient(to right, #4891ff, #21cfff);
      color: #fff;
      padding-left: 20px;

      .submit-text {
        position: relative;
        top: -10px;
        cursor: pointer;
        width: 60px;
        text-align: center;
      }

      .custom-row {
        .custom-col {
          margin-right: 20px;

          &:first-child,
          &:nth-child(5) {
            margin-right: 40px;
          }

          &:nth-child(2) {
            margin-right: auto;
            margin-top: -10px;
          }
        }
      }
    }

    .card-make-box {
      display: flex;
      flex: auto;
      box-sizing: border-box;
      height: calc(100vh - 60px) !important;
      overflow: hidden;

      .bd-le {
        height: 100%;
        overflow-y: auto;

        flex: 1;
        height: 100%;
        overflow: scroll;
        position: relative;
        // padding-bottom: 100px;
        // overflow: visible;
      }

      .bd-ri {
        position: relative;
        float: right;
        width: 440px;
        background: #fff;
        height: 100%;
        overflow-y: auto;
      }

      .disabled_mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #000;
        z-index: 9;
        cursor: not-allowed;
        opacity: 0.3;
      }

      .fix-box {
        position: absolute;
        left: -15px;
        top: 100px;
      }

      .card-content {
        // font-size: 3mm;
        //font-family: 宋体, SimSun, "STSong";
        // font-family: "Verdana", "宋体";
        position: relative;
        color: var(--card-color);
        width: 794px;
        margin: 0 auto;
      }
    }

    .preview-wrapper {
      display: block;
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      overflow: auto;
      z-index: -1;
      // font-family: "Verdana", "宋体";
      color: #000;
      background: #f1f1f1;

      .close-down {
        position: fixed;
        top: 10px;
        right: 100px;
        z-index: 10;
        padding: 6px 8px;
        border-radius: 8px;
        border: 1px solid #f8f8f8;
        box-shadow: rgba(0, 0, 0, 0.1) 0 2px 5px 4px;
        z-index: 1000;
        display: flex;
        align-items: center;
      }

      .close {
        border: 1px solid #fff;
        position: fixed;
        margin-top: 10px;
        font-size: 42px;
        right: 30px;
        z-index: 1004;
        cursor: pointer;
        background: #fff;
        border-radius: 25px;
      }

      .close_wait {
        cursor: wait;
      }

      .card-content {
        margin: 0 auto;
        height: 100%;
        position: relative;
      }

      .topic-box {
        overflow: hidden;

        .topic-bd {
          word-break: break-word;
        }

        p.row {
          min-height: 38px;
          line-height: 38px;
          word-spacing: 0;
        }

        p {
          min-height: 38px;
          margin: 0 !important;
        }

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }

    .page-cell {
      //border: solid 1px black;
      background: #fff;
      //height: 1123px;
      padding: 0;

      .position_point {
        position: absolute;
        width: 22px;
        height: 11px;
        background: #000;
      }

      #barcode {
        position: absolute;
        width: 100px;
        height: 50px;
        bottom: 4px;
        z-index: 999;
        right: -53px;
      }

      .left {
        left: 16px;
        top: 25px;
      }

      .top {
        right: 16px;
        top: 25px;
      }

      .bottom {
        bottom: 25px;
        left: 16px;
      }

      .right {
        right: 16px;
        bottom: 25px;
      }
    }

    .ck-content,
    .ck-content.ck-editor__editable_inline,
    .ck-content.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused {
      // padding: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }

    .topic-box {
      position: relative;
      // overflow: hidden;
      // margin-top: 10px;
    }

    .topic-th {
      position: relative;
      min-height: 40px;
      line-height: 40px;
      font-size: 14px;
    }

    .topic-bd {
      position: relative;
      overflow: hidden;
      // border: 1px solid #000 !important;
      border: 1px solid var(--card-color);

      .move-h {
        position: absolute;
        right: 0;
        bottom: 0;
        color: #409eff;
        font-size: 20px;
        z-index: 2004;
        cursor: pointer;
      }

      .ck-content {
        position: relative;
        width: 100%;
        height: 100%;
      }

      .ck-content.ck-editor__editable_inline> :last-child {
        margin-bottom: 0;
      }

      .ck-content.ck-editor__editable_inline> :first-child {
        padding-top: 39px;
        margin-top: 0 !important;
      }
    }

    .kfformula {
      vertical-align: middle;
    }

    .move-tips {
      position: absolute;
      left: 101%;
      bottom: 0;
      width: 100px;
    }

    #div1 {
      min-height: 100px;
      width: 100%;
      border: 1px solid #000;
    }
  }

  #preview-page {
    pointer-events: none !important;
  }

  #preview-page-wrap {
    .ab-box {
      border: none !important;
    }
  }

  .red-card {
    border: 1px solid var(--card-color);
    border-radius: 5px;

    .basic-card {
      border: 1px solid var(--card-color);
      border-radius: 5px;
      padding: 5px;

      .i-cont {
        border-bottom: 1px solid var(--card-color);
      }
    }

    .ab-box {
      border: 1px solid var(--card-color) !important;
      border-radius: 4px !important;
      border-bottom: none !important;
      border-radius: inherit !important;
    }

    .group {
      .gro-item {
        color: var(--card-color);

        &:first-child {
          color: #000;
        }
      }
    }
  }

  .card-name {
    text-align: center;
  }

  .qrcodeBox {
    position: absolute;
    width: 68px;
    height: 68px;
    left: 0;
    top: 0;
    overflow: hidden;
  }
</style>